import { MAX_GRID_WIDTH } from "config/styleConsts";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { Dots } from "modules/common/components/Trustpilot/Dots";
import { useState } from "react";
import { ChakraBox as Box, ChakraHeading as Heading, ChakraFlex as Flex } from "@airhelp/react-ui-components";
import type { SbEditableComponentProps } from "types/storyblok";
import { TestimonialCard } from "./TestimonialCard";
import type { TestimonialsProps } from "./Testimonials.d";

export const Testimonials = ({
  title,
  cards,
  id,
  display = "flex",
  sbEditable,
}: SbEditableComponentProps<TestimonialsProps>) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const [sliderRef, instanceRef] = useKeenSlider({
    mode: "snap",
    slides: {
      origin: "center",
      perView: "auto",
      spacing: 32,
    },

    initial: 0,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel);
    },
  });

  const goToSlide = (slideIndex: number) => instanceRef.current?.moveToIdx(slideIndex);

  const showSlider = cards.length > 1;

  return (
    <Flex flexDir="column" pos="relative" py={{ base: 8, lg: 16 }} id={id} display={display} {...sbEditable}>
      <Heading
        variant="h2"
        maxW={MAX_GRID_WIDTH}
        mx="auto"
        color="primary.900"
        textAlign="center"
        px={{ base: 8, md: "unset" }}
      >
        {title}
      </Heading>
      {showSlider ? (
        <>
          <Box ref={sliderRef} className="keen-slider" py={{ base: 5, lg: 10 }}>
            {cards.map((card) => (
              <Box
                className="keen-slider__slide"
                key={card.author}
                px={{ base: 8, lg: 12, xl: "unset" }}
                minW="fit-content"
                maxW="fit-content"
              >
                <TestimonialCard {...card} />
              </Box>
            ))}
          </Box>
          <Box
            mx="auto"
            maxW={MAX_GRID_WIDTH}
            px={{ base: 4, lg: 8 }}
            bg="greyscale.300"
            pos="absolute"
            borderRadius="2xl"
            left={{ base: 4, lg: 8 }}
            top={0}
            bottom={0}
            right={{ base: 4, lg: 8 }}
            zIndex="-1"
          />
          <Box maxW={MAX_GRID_WIDTH} mx="auto">
            <Dots currentSlide={currentSlide} numberOfSlides={cards.length} goToSlide={goToSlide} color="primary.500" />
          </Box>
        </>
      ) : (
        <>
          <Flex margin="auto" pt={{ base: 5, lg: 10 }} justify="center">
            <TestimonialCard {...cards[0]} mx={{ base: 8, lg: 14 }} />
          </Flex>
          <Box
            mx="auto"
            maxW={MAX_GRID_WIDTH}
            px={{ base: 4, lg: 8 }}
            bg="greyscale.300"
            pos="absolute"
            borderRadius="2xl"
            left={{ base: 4, lg: 8 }}
            top={0}
            bottom={0}
            right={{ base: 4, lg: 8 }}
            zIndex="-1"
          />
        </>
      )}
    </Flex>
  );
};
